module.exports = __webpack_public_path__ + "img/wx-qrcode1.c992a446.jpg";